var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explain"},[_c('div',[_vm._v("\n    退订说明：请在距离到店时间24小时前免费退订，超出视为已使用。\n    "),_c('br'),_c('br'),_vm._v("\n    预约须知：根据酒店健身中心规定，为安全起见，游泳、健身不接收年龄在70岁以上（包括70岁）的客人进入，未成年人下场时需成年人陪同进入。\n\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75878496","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subgroup/appointmentExplainFit.vue
// module id = 4j5t
// module chunks = 0